module.exports = __webpack_public_path__ + "img/icons-list.44c1368d.svg";